import 'dotenv/config'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'

import i18n from '@optios-frontend-website/shared-ui/src/i18n'
import './index.css'
import 'react-toastify/dist/ReactToastify.css'
import * as serviceWorker from './serviceWorker'
import Modal from 'react-modal'
import { Provider } from 'react-redux'
import { store } from 'store'
import Bootstrap from './Bootstrap'
import Spinner from 'shared/Spinner'

Modal.setAppElement('#root')
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Spinner isLoaded={true} />}>
          <Router>
            <Bootstrap />
          </Router>
        </Suspense>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
